import Button, { ButtonProps } from "@mui/material/Button";

interface Props extends ButtonProps {
  component?: any;
  to?: any;
}

const RegularButton = ({ children, ...props }: Props) => {
  return (
    <span>
      <Button
        sx={{
          textTransform: "none",
          color: (theme) =>
            theme.palette.mode === "dark"
              ? "text.primary"
              : theme.palette.primary.main,
          background: (theme) =>
            theme.palette.mode === "dark"
              ? theme.palette.background.paper
              : theme.palette.primary.light,
          "&:hover": {
            background: (theme) =>
              theme.palette.mode === "dark"
                ? theme.palette.background.default
                : theme.palette.primary.light,
          },
        }}
        {...props}
      >
        {children}
      </Button>
    </span>
  );
};

export { RegularButton };
